import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ReferralUpdatesService {
  readonly #changes = new Subject<void>();
  readonly changes$ = this.#changes.asObservable();

  notifyChanged(): void {
    this.#changes.next();
  }
}
